/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Task statuses.
 */
export enum TaskStatus {
  DISABLED = 'disabled',
  EXCEPTION = 'exception',
  READY = 'ready',
  COMPLETE = 'complete',
  NOT_NEEDED = 'not_needed',
  DEFERRED = 'deferred',
  LOCKED = 'locked',
}
